{
  "adhoc": {
    "archiveQuestion": "Archiver la question",
    "confirmArchiveMessage": "Êtes-vous sûr de vouloir archiver cette question ? Elle sera déplacée dans les archives.",
    "confirmDeletePermanentlyMessage": "Voulez-vous vraiment supprimer définitivement cette question ? Cette action est irréversible.",
    "confirmRestoreMessage": "Voulez-vous vraiment restaurer cette question ? Elle sera de nouveau visible.",
    "deleteQuestionPermanently": "Supprimer définitivement la question",
    "noResultsYet": "Pas encore de résultats",
    "restoreQuestion": "Restaurer la question",
    "runSimulationToSeeResults": "Lancez la question pour voir les résultats ici",
    "triggeringQuestion": "Démarrage..."
  },
  "audienceBuilder": {
    "addBehaviorGroup": "Ajouter un groupe de comportements",
    "addMarket": "Ajouter un segment",
    "addingMarket": "Ajout du segment...",
    "ageRange": "Tranche d'âge",
    "allGenders": "Tous les genres",
    "audienceSummary": "Résumé de l'audience",
    "behaviorGroup": "Groupe de comportements {{index}}",
    "behaviors": "Comportements",
    "completedSummary": {
      "one": "Votre étude a atteint {{respondents}} répondants sur {{count}} segment.",
      "other": "Votre étude a atteint {{respondents}} répondants sur {{count}} segments.",
      "zero": "Votre étude a atteint {{respondents}} répondants."
    },
    "continue": "Continuer",
    "countries": "Pays",
    "countryCount": {
      "one": "{{count}} pays",
      "other": "{{count}} pays",
      "zero": "Monde entier"
    },
    "demographics": "Filtrer la démographie",
    "demographicsReadonly": "Démographie",
    "equalizeWeights": "Égaliser",
    "extraFilters": {
      "one": "+{{count}} filtre",
      "other": "+{{count}} filtres",
      "zero": "Aucun filtre"
    },
    "gender": "Genre",
    "genderAgeSummary": "{{gender}}, {{ageMin}}-{{ageMax}}",
    "inProgressSummary": "Votre étude est en cours. Les résultats seront disponibles sous peu.",
    "launchBlockedByErrors": {
      "one": "{{count}} erreur à corriger",
      "other": "{{count}} erreurs à corriger"
    },
    "launchEstimate": {
      "one": "Résultats en environ {{count}} minute.",
      "other": "Résultats en environ {{count}} minutes.",
      "zero": "Résultats en moins d'une minute."
    },
    "launchStudy": "Lancer l'étude",
    "launchSummary": {
      "one": "Votre étude atteindra {{respondents}} répondants sur {{count}} segment.",
      "other": "Votre étude atteindra {{respondents}} répondants sur {{count}} segments.",
      "zero": "Votre étude atteindra {{respondents}} répondants."
    },
    "mapViewWorld": "Monde",
    "mapWebOnly": "Carte disponible uniquement sur le web",
    "marketName": "Segment {{number}}",
    "presetAfrica": "Afrique",
    "presetAsia": "Asie",
    "presetEurope": "Europe",
    "presetMiddleEast": "Moyen-Orient",
    "presetNorthAmerica": "Amérique du Nord",
    "presetOceania": "Océanie",
    "presetSouthAmerica": "Amérique du Sud",
    "questionSubtitle": "Rédigez votre question et configurez les options de réponse ci-dessous.",
    "questionTitle": "Que souhaitez-vous demander ?",
    "readyToLaunch": "Prêt à lancer",
    "respondentsShort": "{{count}} rép.",
    "resultsSubtitle": "Consultez les résultats de votre simulation d'audience",
    "resultsTitle": "Résultats",
    "sampleSize": "Taille de l'échantillon pour cette étude",
    "savedMarket": "Segment enregistré",
    "savedMarkets": "Segments enregistrés",
    "searchCountries": "Rechercher des pays",
    "searchStates": "Rechercher des états",
    "seeProgress": "Voir la progression",
    "seeResults": "Voir les résultats",
    "selectCountries": "Sélectionner des pays",
    "selectSegmentHint": "Sélectionnez un segment pour continuer",
    "selectedDemographics": {
      "one": "{{label}} : {{count}} filtre",
      "other": "{{label}} : {{count}} filtres",
      "zero": "Aucun {{label}}"
    },
    "stepAudience": "Audience",
    "stepQuestion": "Question",
    "stepResults": "Résultats",
    "studyComplete": "Étude terminée",
    "studyInProgress": "Étude en cours",
    "studyQuestionsSubtitle": "Construisez les questions et sections de votre étude.",
    "studyQuestionsTitle": "Concevez votre étude",
    "subtitle": "Choisissez un segment sauvegardé, décrivez votre audience ou personnalisez les filtres ci-dessous.",
    "title": "Qui souhaitez-vous atteindre ?"
  },
  "auth": {
    "subtitle": "La recherche continue pour les marques qui avancent vite.",
    "tagline": "Simulez chaque audience, ",
    "taglineItalic": "obtenez des insights en quelques minutes"
  },
  "billing": {
    "activity": "Activité",
    "columnAmount": "Montant",
    "columnCredits": "Crédits",
    "columnDate": "Date",
    "columnInvoice": "Facture",
    "columnStatus": "Statut",
    "columnType": "Type",
    "creditBalance": "Solde de crédits",
    "currentPlan": "Plan actuel",
    "estimatedCost": {
      "one": "Coût estimé : {{count}} crédit",
      "other": "Coût estimé : {{count}} crédits"
    },
    "intervalDay": "Quotidien",
    "intervalMonth": "Mensuel",
    "intervalWeek": "Hebdomadaire",
    "intervalYear": "Annuel",
    "invoices": "Factures",
    "manage": "Gérer",
    "next": "Suivant",
    "noInvoices": "Aucune facture trouvée.",
    "noPlan": "Aucun plan actif",
    "noTransactions": "Aucune activité trouvée.",
    "pageOf": "Page {{current}} sur {{total}}",
    "previous": "Précédent",
    "quickInsights": "Questions rapides",
    "statusPending": "En attente",
    "statusProcessed": "Traité",
    "study": "Étude",
    "subscribe": "S'abonner",
    "subtitle": "Gérez vos crédits, abonnement et factures.",
    "title": "Facturation",
    "type": {
      "adjustment": "Ajustement",
      "hold": "Réservation de crédits",
      "refund": "Remboursement",
      "subscription": "Renouvellement d'abonnement",
      "topup": "Achat de crédits",
      "usage": "Utilisation de simulation"
    },
    "unlimited": "Illimité"
  },
  "clerk": {
    "newDeviceNotice": "Vous vous connectez depuis un nouvel appareil. Par sécurité, nous vous avons envoyé un code de vérification. Il peut mettre jusqu'à une minute à arriver. Pensez à vérifier vos spams.",
    "noAccount": "Vous n'avez pas de compte ?",
    "requestFreeTrial": "Demander un essai gratuit",
    "resendCode": "Toujours rien ? Renvoyer un code",
    "waitlistAlreadyAccess": "Vous avez déjà accès ?",
    "waitlistSignIn": "Se connecter",
    "waitlistSubtitle": "Entrez votre adresse e-mail pour demander un essai gratuit de 7 jours",
    "waitlistSuccessMessage": "Vous serez redirigé bientôt...",
    "waitlistSuccessSubtitle": "Nous vous contacterons sous peu",
    "waitlistSuccessTitle": "Merci d'avoir demandé un essai gratuit !",
    "waitlistTitle": "Essai gratuit"
  },
  "dashboard": {
    "activeStudies": "Études",
    "activeStudiesCount": {
      "one": "{{count}} active",
      "other": "{{count}} actives",
      "zero": "Aucune active"
    },
    "activeStudiesDescription": "Pour des recherches avancées et approfondies qui nécessitent plus de contrôle",
    "allUseCases": "Tous les tests",
    "customTest": "Test personnalisé",
    "errorLoadingStudies": "Impossible de charger les études",
    "getStarted": "Commencer",
    "linearScaleDescription": "Échelles numériques personnalisées",
    "managePanels": "Segments enregistrés",
    "managePanelsDescription": "Configurez les données démographiques et paramètres de vos segments",
    "multiSelectMatrixDescription": "Plusieurs sélections par ligne en grille",
    "multipleChoiceDescription": "Sélectionnez toutes les options valides",
    "noLaunchPermission": "Vous n'avez pas les permissions nécessaires pour lancer cette simulation.",
    "noRecentStudies": "Aucune étude récente",
    "npsDescription": "Probabilité de recommandation, sur une échelle de 0 à 10",
    "openEndedDescription": "Recueillez des réponses libres",
    "pastQuestions": "Questions précédentes",
    "pricingDescription": "Demandez aux répondants d'indiquer le prix qu'ils paieraient pour un produit ou un service.",
    "questionCount": {
      "one": "{{count}} question",
      "other": "{{count}} questions",
      "zero": "Aucune question"
    },
    "quickActions": "Actions rapides",
    "quickInsights": "Tests rapides",
    "quickInsightsDescription": "Lancez des tests rapides sur des publicités, packagings, claims et plus, avec nos modèles prêts à l'emploi.",
    "quickTests": "Tests rapides",
    "rankingDescription": "Classez les éléments selon n'importe quel critère",
    "ratingScaleDescription": "Évaluez sur une échelle numérique",
    "recentStudies": "Études récentes",
    "seeMore": "Voir plus",
    "singleChoiceDescription": "Choisissez une réponse dans une liste",
    "singleSelectMatrixDescription": "Une sélection par ligne en grille",
    "useCases": {
      "adCreative": "Test Créa Pub",
      "adCreativeDescription": "Présentez vos publicités à chaque consommateur, une à la fois, en mesurant ce qu'ils en retiennent, à quel point ils les apprécient et l'intérêt suscité.",
      "awareness": "Notoriété de Marque",
      "awarenessDescription": "Mesurez combien de consommateurs pensent à chaque marque de votre catégorie d'eux-mêmes, et combien la reconnaissent dans une liste.",
      "claimTest": "Test de Claims",
      "claimTestDescription": "Présentez vos claims à chaque consommateur, un à la fois, en mesurant ce qu'ils en comprennent, leur crédibilité ressentie et leur capacité à motiver.",
      "maxDiff": "MaxDiff",
      "maxDiffDescription": "Montrez aux consommateurs de petits groupes d'éléments à classer du meilleur au pire, sur plusieurs tours, pour révéler ce qui compte.",
      "monadic": "Test de concepts",
      "monadicDescription": "Présentez à chaque consommateur un seul concept à la fois, pour que chaque idée soit jugée seule et non à côté d'une autre.",
      "nps": "NPS",
      "npsDescription": "Demandez aux consommateurs s'ils recommanderaient votre produit sur une échelle de 0 à 10, et la raison de leur note.",
      "packaging": "Test de packaging",
      "packagingDescription": "Présentez vos packagings à chaque consommateur, un à la fois, en mesurant le produit perçu, leur attrait et leur visibilité en rayon.",
      "preferenceTest": "Test de préférence",
      "preferenceTestDescription": "Montrez aux consommateurs deux options ou plus côte à côte (publicités, packagings, claims) et découvrez laquelle ils préfèrent, et pourquoi.",
      "priceElasticity": "Élasticité Prix",
      "priceElasticityDescription": "Identifiez la fourchette où les consommateurs voient une vraie valeur, ce qui paraît trop bon marché, trop cher, ou juste comme il faut.",
      "turf": "TURF",
      "turfDescription": "Trouvez le plus petit assortiment, pour un rayon, un menu ou une gamme, qui satisfait le plus large éventail de goûts."
    },
    "viewAll": "Voir tout",
    "welcome": "Bienvenue, {{name}} !",
    "welcomeDescription": "Que souhaitez-vous tester aujourd'hui ?",
    "yourFavorites": "Vos favoris"
  },
  "dashboardNavigator": {
    "accountLanguageDefault": "Langue du compte (Par défaut)",
    "accountProfile": "Profil",
    "accountSecurity": "Sécurité",
    "accountSecurityDescription": "Gérez votre mot de passe, appareils et sessions actives.",
    "accountSettings": "Paramètres du compte",
    "activeSessions": "Sessions actives",
    "addEmailPlaceholder": "Ajouter une adresse email",
    "age": "{{age}} ans",
    "ageRange": "L'âge doit être entre {{lowerBound}} et {{upperBound}} ans",
    "allGroups": "Tous les groupes",
    "archives": "Archives",
    "areaType": "Type de zone",
    "avgRank": "Rang moy.",
    "behaviorLabel": "Comportement",
    "behaviorPlaceholder": "Préfère acheter en ligne",
    "behaviors": {
      "one": "1 comportement",
      "other": "{{count}} comportements",
      "zero": "Aucun comportement"
    },
    "browserDefault": "Navigateur (Par défaut)",
    "cannotUnlinkLastAccount": "Vous devez avoir au moins une méthode de connexion. Définissez d'abord un mot de passe pour dissocier ce compte.",
    "changePassword": "Changer le mot de passe",
    "chartTitleDistribution": {
      "one": "Distribution (1 réponse)",
      "other": "Distribution ({{count}} réponses)",
      "zero": "Distribution (Aucun répondant)"
    },
    "chartTitleHeatmap": {
      "one": "Carte thématique (1 réponse)",
      "other": "Carte thématique ({{count}} réponses)",
      "zero": "Carte thématique (Aucun répondant)"
    },
    "chartTitleKeyThemes": {
      "one": "Thèmes clés (1 réponse)",
      "other": "Thèmes clés ({{count}} réponses)",
      "zero": "Thèmes clés (Aucun répondant)"
    },
    "chartTitleNps": {
      "one": "Net Promoter Score (1 répondant)",
      "other": "Net Promoter Score ({{count}} répondants)",
      "zero": "Net Promoter Score (Aucun répondant)"
    },
    "chartTitleNpsBreakdown": {
      "one": "Répartition NPS (1 répondant)",
      "other": "Répartition NPS ({{count}} répondants)",
      "zero": "Répartition NPS (Aucun répondant)"
    },
    "chartTitlePriceDistribution": {
      "one": "Distribution des prix (1 répondant)",
      "other": "Distribution des prix ({{count}} répondants)",
      "zero": "Distribution des prix (Aucun répondant)"
    },
    "chartTitleRatings": {
      "one": "Note moyenne (1 répondant)",
      "other": "Note moyenne ({{count}} répondants)",
      "zero": "Note moyenne (Aucun répondant)"
    },
    "chartTitleRatingsBreakdown": {
      "one": "Répartition des notes (1 répondant)",
      "other": "Répartition des notes ({{count}} répondants)",
      "zero": "Répartition des notes (Aucun répondant)"
    },
    "chartTitleResponseDistribution": {
      "one": "Répartition des choix (1 répondant)",
      "other": "Répartition des choix ({{count}} répondants)",
      "zero": "Répartition des choix (Aucun répondant)"
    },
    "chartTitleResponseMatrix": {
      "one": "Réponses par catégorie (1 répondant)",
      "other": "Réponses par catégorie ({{count}} répondants)",
      "zero": "Réponses par catégorie (Aucun répondant)"
    },
    "chartTitleResponseRanking": {
      "one": "Répartition du classement (1 répondant)",
      "other": "Répartition du classement ({{count}} répondants)",
      "zero": "Répartition du classement (Aucun répondant)"
    },
    "chartTitleScoreDistribution": {
      "one": "Répartition des scores (1 répondant)",
      "other": "Répartition des scores ({{count}} répondants)",
      "zero": "Répartition des scores (Aucun répondant)"
    },
    "chartTitleTopResponses": {
      "one": "Principales réponses (1 réponse)",
      "other": "Principales réponses ({{count}} réponses)",
      "zero": "Principales réponses (Aucun répondant)"
    },
    "chartTooltipHeatmap": "{{line}} : {{option}}",
    "children": {
      "one": "1 enfant",
      "other": "{{count}} enfants",
      "zero": "Aucun enfant"
    },
    "comingSoon": "Prochainement",
    "comingSoonDescription": "Nous travaillons sur l'intégration avec ces plateformes pour vous aider à exécuter des simulations sur vos propres données. Restez à l'écoute pour les mises à jour !",
    "confirmDeleteGroup": "Supprimer le groupe",
    "confirmDeleteGroupMessage": "Êtes-vous sûr de vouloir supprimer ce groupe ? Cette action ne peut pas être annulée.",
    "confirmPassword": "Confirmer le mot de passe",
    "connectedAccounts": "Comptes connectés",
    "conversation": "Conversation",
    "count": "Nombre",
    "current": "Actuelle",
    "currentPassword": "Mot de passe actuel",
    "dataSources": "Sources de données",
    "dataSourcesExplanation": "Connectez vos sources de données pour exécuter des simulations sur vos propres personas.",
    "deleteEmail": "Supprimer l'email",
    "deleteEmailConfirm": "Êtes-vous sûr de vouloir supprimer {{email}} ?",
    "demographics": "Démographie",
    "devices": {
      "one": "1 appareil",
      "other": "{{count}} appareils",
      "zero": "Aucun appareil"
    },
    "educationLabel": "Éducation",
    "emailAddresses": "Adresses email",
    "employmentStatus": "Emploi",
    "enterFirstName": "Entrez votre prénom",
    "enterLastName": "Entrez votre nom",
    "errorLoadingConversation": "Échec du chargement de la conversation",
    "errorLoadingDemographics": "Échec du chargement des données démographiques",
    "ethnicity": "Origine ethnique",
    "firstName": "Prénom",
    "home": "Accueil",
    "householdLabel": "Taille du foyer",
    "income": "Revenus",
    "keyInsights": "Insights clés",
    "languageSettings": "Paramètres de langue",
    "lastName": "Nom",
    "linearScaleQuestionTitle": "Échelle linéaire",
    "location": "Localisation",
    "locationUnknown": "Localisation inconnue",
    "logout": "Déconnexion",
    "logoutConfirm": "Êtes-vous sûr de vouloir vous déconnecter de votre compte ?",
    "maritalStatus": "Situation familiale",
    "maxSmallerThanMin": "Le max doit être supérieur au min",
    "multiSelectMatrixQuestionTitle": "Matrice à sélection multiple",
    "multipleChoiceQuestionTitle": "Choix multiples",
    "newPassword": "Nouveau mot de passe",
    "noActiveSessions": "Aucune session active",
    "noConnectedAccounts": "Aucun compte connecté",
    "noData": "Aucune donnée disponible",
    "noPasswordSet": "Aucun mot de passe défini",
    "npsDetractors": "Détracteurs",
    "npsPassives": "Passifs",
    "npsPromoters": "Promoteurs",
    "npsQuestionTitle": "NPS",
    "npsScale": "−100 à 100",
    "occupation": "Profession",
    "openEndedQuestionTitle": "Question ouverte",
    "organization": "Organisation",
    "organizationAdmin": "Admin",
    "organizationDescription": "Consultez les membres, gérez les rôles et les détails de l'organisation.",
    "organizationDomains": "Domaines vérifiés",
    "organizationFullName": "Nom complet",
    "organizationMember": "Membre",
    "organizationMembers": "Membres",
    "organizationNoDomains": "Aucun domaine vérifié",
    "organizationNoMembers": "Aucun membre trouvé",
    "organizationOwner": "Propriétaire",
    "organizationRole": "Rôle",
    "organizationYou": "Vous",
    "panels": "Segments",
    "password": "Mot de passe",
    "passwordEnabled": "Mot de passe activé",
    "passwordProtected": "Votre compte est protégé par un mot de passe",
    "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
    "passwordUpdateFailed": "Échec de la mise à jour du mot de passe. Veuillez vérifier votre mot de passe actuel.",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
    "personalInformation": "Informations personnelles",
    "personality": "Personnalité",
    "pricingQuestionTitle": "Question de prix",
    "primary": "Principal",
    "questions": "Questions",
    "rankingQuestionTitle": "Classement",
    "ratingScaleQuestionTitle": "Évaluation",
    "regionTypeRural": "Rural",
    "regionTypeSuburban": "Suburbain",
    "regionTypeUrban": "Urbain",
    "respondents": {
      "one": "1 répondant",
      "other": "{{count}} répondants",
      "zero": "Aucun répondant"
    },
    "results": "Résultats",
    "revoke": "Révoquer",
    "revokeSession": "Révoquer la session",
    "revokeSessionConfirm": "Cela déconnectera cet appareil. L'utilisateur devra se reconnecter.",
    "revoking": "Révocation...",
    "seeAllCount": {
      "one": "Voir tout (1 verbatim)",
      "other": "Voir tout ({{count}} verbatims)",
      "zero": "Voir tout"
    },
    "setPassword": "Définir un mot de passe",
    "setPasswordPrompt": "Ajoutez un mot de passe pour sécuriser votre compte",
    "settings": "Paramètres",
    "settingsDescription": "Gérez vos préférences linguistiques et vos paramètres de sécurité.",
    "signOut": "Déconnexion",
    "signOutDescription": "Déconnectez-vous de votre compte sur cet appareil.",
    "singleChoiceQuestionTitle": "Choix unique",
    "singleSelectMatrixQuestionTitle": "Matrice à sélection unique",
    "studies": "Études",
    "studyLanguage": "Langue des études",
    "studyLanguageDescription": "Définissez la langue par défaut pour vos études et sondages.",
    "traits": "Traits",
    "unknownDevice": "Appareil inconnu",
    "unlink": "Dissocier",
    "unlinkAccount": "Dissocier le compte",
    "unlinkAccountConfirm": "Êtes-vous sûr de vouloir dissocier votre compte {{provider}} ? Vous ne pourrez plus vous connecter avec ce compte.",
    "unlinking": "Dissociation...",
    "values": "Valeurs",
    "verificationCode": "Code de vérification",
    "verifyEmail": "Entrez le code de vérification envoyé à {{email}}",
    "websiteLanguage": "Langue du site web",
    "websiteLanguageDescription": "Définissez la langue d'affichage de l'interface du site.",
    "weight": "Poids",
    "whatConsumersSaid": "Ce que les consommateurs ont dit"
  },
  "dataSources": {
    "aws": "AWS",
    "awsDescription": "Amazon Web Services",
    "codence": "Codence",
    "codenceDescription": "Plateforme de recherche client",
    "dovetail": "Dovetail",
    "dovetailDescription": "Hub d'informations client IA",
    "enjoyHQ": "EnjoyHQ",
    "enjoyHQDescription": "Référentiel de recherche utilisateur",
    "googleAds": "Google Ads",
    "googleAdsDescription": "Plateforme publicitaire Google",
    "googleCloud": "Google Cloud",
    "googleCloudDescription": "Plateforme Google Cloud",
    "hubspot": "Hubspot",
    "hubspotDescription": "Plateforme marketing et ventes",
    "maze": "Maze",
    "mazeDescription": "Plateforme de découverte produit",
    "metaAds": "Meta Ads",
    "metaAdsDescription": "Publicités Facebook et Instagram",
    "microsoftAzure": "Microsoft Azure",
    "microsoftAzureDescription": "Plateforme cloud Microsoft",
    "oracleCloud": "Oracle Cloud",
    "oracleCloudDescription": "Infrastructure cloud Oracle",
    "salesforce": "Salesforce",
    "salesforceDescription": "Gestion de la relation client",
    "tiktokAds": "TikTok Ads",
    "tiktokAdsDescription": "Plateforme publicitaire TikTok"
  },
  "demographics": {
    "female": "Femme",
    "male": "Homme",
    "nonBinary": "Non-binaire"
  },
  "folders": {
    "confirmArchive": "Archiver le dossier",
    "confirmArchiveMessage": "Êtes-vous sûr de vouloir archiver \"{{name}}\" ? Tout le contenu à l'intérieur sera également archivé.",
    "confirmDeletePermanentlyMessage": "Êtes-vous sûr de vouloir supprimer définitivement ce dossier et tout son contenu ? Cette action est irréversible.",
    "confirmRestoreMessage": "Êtes-vous sûr de vouloir restaurer ce dossier ? Tout le contenu à l'intérieur sera également restauré.",
    "currentLocation": "Emplacement actuel",
    "deleteFolderPermanently": "Supprimer le dossier définitivement",
    "errorLoadingFolders": "Impossible de charger les dossiers",
    "folderNamePlaceholder": "Nom du dossier...",
    "moveItem": "Déplacer {{name}}",
    "newFolder": "Nouveau dossier",
    "noFoldersYet": "Aucun dossier",
    "rename": "Renommer le dossier",
    "renameFolder": "Renommer",
    "subFolderCount": {
      "one": "{{count}} sous-dossier",
      "other": "{{count}} sous-dossiers"
    }
  },
  "menu": {
    "account": "Compte",
    "accountDescription": "Gérez votre profil, vos adresses e-mail et vos comptes connectés.",
    "archives": "Archives",
    "billing": "Facturation",
    "logout": "Déconnexion",
    "logoutConfirm": "Êtes-vous sûr de vouloir vous déconnecter de votre compte ?",
    "managePlan": "Gérer l'abonnement",
    "openMenu": "Ouvrir le menu",
    "organization": "Organisation",
    "settings": "Paramètres",
    "subscribe": "S'abonner"
  },
  "misc": {
    "apply": "Appliquer",
    "archive": "Archiver",
    "archived": "Archivé",
    "archivedQuestionBanner": "Vous consultez une question archivée. Restaurez-la pour apporter des modifications.",
    "archivedStudyBanner": "Vous consultez une étude archivée. Restaurez-la pour apporter des modifications.",
    "archivesEmptyDescription": "Les éléments archivés apparaîtront ici.",
    "archiving": "Archivage...",
    "back": "Retour",
    "cancel": "Annuler",
    "close": "Fermer",
    "completed": "Terminé",
    "create": "Créer",
    "creating": "Création...",
    "creatingStudy": "Création de l'étude...",
    "delete": "Supprimer",
    "deletePermanently": "Supprimer définitivement",
    "deleting": "Suppression...",
    "draft": "Brouillon",
    "dropFilesHere": "Déposez les fichiers ici",
    "duplicate": "Dupliquer",
    "duplicating": "Duplication...",
    "edit": "Modifier",
    "errorLoadingQuestion": "Échec du chargement de la question",
    "errorLoadingQuestions": "Échec du chargement des questions",
    "errorOccurred": "Une erreur s'est produite.",
    "failed": "Échoué",
    "failedToGenerateSummary": "Échec lors de la génération du résumé.",
    "fileSizeExceededImage": "L'image dépasse la taille maximale de {{maxSize}} Mo",
    "fileSizeExceededVideo": "La vidéo dépasse la taille maximale de {{maxSize}} Mo",
    "filesRejected": "{{count}} fichiers rejetés : {{reason}}",
    "generatingSummary": "Génération du résumé…",
    "hoursShort": "{{count}}h",
    "imageUpToSize": "Images jusqu'à {{maxSize}} Mo chacune",
    "in_progress": "En cours",
    "invalidImageFormat": "Format d'image invalide. Veuillez téléverser des images JPEG, PNG, GIF ou WebP.",
    "invalidMediaFormat": "Format de fichier invalide. Veuillez téléverser des images ou des vidéos valides.",
    "invalidVideoFormat": "Format de vidéo invalide. Veuillez téléverser des vidéos MP4 ou WebM.",
    "loading": "Chargement...",
    "maxItemsReached": "Maximum de {{max}} éléments autorisés",
    "mediaUpToSize": "Images jusqu'à {{imageMaxSize}} Mo chacune, vidéos jusqu'à {{videoMaxSize}} Mo chacune",
    "minutesShort": "{{count}}m",
    "move": "Déplacer",
    "moving": "Déplacement...",
    "noArchivedQuestions": "Aucune question archivée",
    "noArchivedQuestionsDescription": "Les questions archivées apparaîtront ici.",
    "noArchivedSegments": "Aucun segment archivé",
    "noArchivedSegmentsDescription": "Les segments archivés apparaîtront ici.",
    "noArchivedStudies": "Aucune étude archivée",
    "noArchivedStudiesDescription": "Les études archivées apparaîtront ici.",
    "noQuestionsYet": "Aucune question pour le moment",
    "noSearchResults": "Aucun résultat trouvé",
    "noSearchResultsDescription": "Essayez d'ajuster vos termes de recherche",
    "otherValues": "Autres",
    "permissionRequiredMessage": "Désolé, nous avons besoin des autorisations de la galerie pour sélectionner des médias.",
    "readMore": "Lire la suite",
    "ready": "Prêt",
    "reset": "Réinitialiser",
    "restore": "Restaurer",
    "restoring": "Restauration...",
    "retrying": "Nouvelle tentative...",
    "save": "Enregistrer",
    "saving": "Enregistrement...",
    "search": "Rechercher...",
    "searchQuestions": "Rechercher des questions...",
    "searchStudies": "Rechercher des études...",
    "secondsShort": "{{count}}s",
    "seeLess": "Voir moins",
    "seeMore": "Voir plus",
    "selectedImageAlt": "Image sélectionnée {{index}}",
    "showOriginal": "Voir l'original",
    "showTranslation": "Voir la traduction",
    "tapToSelectImages": "Appuyez pour sélectionner des images",
    "tapToSelectMedia": "Appuyez pour sélectionner des fichiers",
    "tapToSelectVideos": "Appuyez pour sélectionner des vidéos",
    "translatedFrom": "Traduit depuis {{language}}",
    "tryAgain": "Réessayer",
    "typeMessage": "Tapez un message...",
    "unknown": "Inconnu",
    "uploadImages": "Téléverser des images (jusqu'à {{max}})",
    "uploadMedia": "Téléverser des médias (jusqu'à {{max}})",
    "uploadVideos": "Téléverser des vidéos (jusqu'à {{max}})",
    "uploadingMedia": {
      "one": "Téléversement de 1 fichier... {{percent}}",
      "other": "Téléversement de {{count}} fichiers... {{percent}}",
      "zero": "Aucun fichier à téléverser"
    },
    "videoUpToSize": "Vidéos jusqu'à {{maxSize}} Mo chacune"
  },
  "notFound": {
    "goToHomeScreen": "Aller à l'écran d'accueil",
    "notFound": "Impossible de trouver ce que vous cherchez"
  },
  "panels": {
    "confirmArchive": "Archiver le segment",
    "confirmArchiveMessage": "Êtes-vous sûr de vouloir archiver ce segment ?\nLes groupes utilisant ce segment continueront à fonctionner mais vous ne pourrez plus utiliser ce segment pour les nouveaux groupes créés.",
    "createPanel": "Créer un segment",
    "default": "Par défaut",
    "demographics": "Démographie",
    "description": "Description",
    "editPanel": "Modifier le segment",
    "errorLoadingPanels": "Échec du chargement des segments",
    "noSegments": "Aucun segment",
    "noSegmentsDescription": "Aucun segment disponible pour le moment.",
    "panelName": "Nom du segment",
    "setAsDefault": "Définir par défaut"
  },
  "questions": {
    "addConditionalRule": "Ajouter une règle conditionnelle",
    "addOption": "Ajouter une option",
    "addProbabilityRule": "Ajouter une règle de probabilité",
    "advancedSettings": "Paramètres avancés",
    "afterThisQuestion": "Après cette question :",
    "archiveQuestion": "Archiver la question",
    "arrow": "→",
    "averagePrice": {
      "one": "Prix moyen (1 répondant)",
      "other": "Prix moyen ({{count}} répondants)",
      "zero": "Prix moyen (Aucun répondant)"
    },
    "averageScore": {
      "one": "Score moyen (1 répondant)",
      "other": "Score moyen ({{count}} répondants)",
      "zero": "Score moyen (Aucun répondant)"
    },
    "carryForward": {
      "exclude": "en excluant les éléments sélectionnés dans Q{{number}}",
      "excludeHint": "Les options sélectionnées dans cette question sont retirées de la liste reportée.",
      "excludeLabel": "Exclure les options sélectionnées dans (facultatif)",
      "minRating": "Afficher uniquement les éléments évalués \"{{label}}\" ou plus dans Q{{number}}",
      "modeManualOptions": "Saisir les options",
      "modeManualRows": "Saisir les lignes",
      "modeReuse": "Réutiliser une réponse précédente",
      "none": "Aucune",
      "portRatedPrefix": "Reporte les lignes évaluées",
      "portRatedSuffix": "ou plus comme {{target}} de cette question.",
      "portSelected": "Reporte les options sélectionnées comme {{target}} de cette question.",
      "reuseFrom": "Réutiliser les réponses de",
      "selected": "Afficher uniquement les éléments sélectionnés dans Q{{number}}",
      "targetOptions": "options",
      "targetRows": "lignes"
    },
    "categoryAssignment": {
      "addCondition": "Ajouter une condition",
      "addTrack": "Ajouter un parcours",
      "eligibilityContains": "Éligibilité : Q{{number}} contient « {{option}} »",
      "eligibilityDoesNotContain": "Éligibilité : Q{{number}} ne contient pas « {{option}} »",
      "eligibilityHint": "Par défaut, chacun peut être placé dans n'importe quel parcours. Ajoutez une condition pour réserver un parcours aux répondants ayant donné une réponse précise.",
      "eligibilityIs": "Éligibilité : Q{{number}} est « {{option}} »",
      "eligibilityIsNot": "Éligibilité : Q{{number}} n'est pas « {{option}} »",
      "eligibleWhen": "Éligible si",
      "explanation": "Les répondants sont répartis entre des parcours. Utilisez l'éligibilité pour contrôler qui peut entrer dans un parcours, et la logique de saut pour orienter chaque parcours vers des questions différentes.",
      "leastFill": "Équilibré",
      "leastFillHint": "Remplit les parcours de façon équilibrée, en affectant toujours au parcours éligible le moins rempli.",
      "method": "Méthode : {{method}}",
      "random": "Aléatoire",
      "randomHint": "Affecte à un parcours éligible au hasard.",
      "setDestination": "Définir la destination",
      "title": "Affectation des parcours",
      "trackLabel": "Parcours {{number}}",
      "trackStart": "Le parcours commence à",
      "tracksLabel": "Parcours"
    },
    "conditionalRuleDisplay": "Si \"{{sourceQuestion}}\" {{operator}} \"{{option}}\" → {{target}}",
    "conditionalRulesTakePrecedence": "Les règles conditionnelles sont prioritaires sur les règles de probabilité et la règle par défaut",
    "confirmArchiveMessage": "Êtes-vous sûr de vouloir archiver cette question ? Elle sera déplacée dans les archives.",
    "confirmDelete": "Supprimer la question",
    "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer cette question ? Cette action ne peut pas être annulée.",
    "confirmDeletePermanentlyMessage": "Voulez-vous vraiment supprimer définitivement cette question ? Cette action est irréversible.",
    "confirmDeleteWithRulesMessage": "Cette question est ciblée par {{count}} règle(s) de saut d'autres questions. La supprimer supprimera également ces règles. Cette action ne peut pas être annulée.",
    "confirmRestoreMessage": "Voulez-vous vraiment restaurer cette question ? Elle sera de nouveau visible.",
    "contains": "contient",
    "continueToNext": "Continuer vers la question suivante",
    "createQuestion": "Créer une question",
    "default": "Par défaut",
    "deleteQuestionPermanently": "Supprimer définitivement la question",
    "doesNotContain": "ne contient pas",
    "editorComingSoon": "Éditeur à venir",
    "endSurvey": "Terminer le sondage",
    "endSurveyWithProbability": "{{percentage}} → Terminer le sondage",
    "enterOption": "Entrez une option...",
    "ifAnswer": "Si",
    "ifNotSelected": "si non sélectionné",
    "ifSelected": "si sélectionné",
    "is": "est",
    "isNot": "n'est pas",
    "labelsTitle": "Libellés",
    "linearScale": {
      "label": "Libellé"
    },
    "longFormTextAnswer": "Réponse texte libre...",
    "matrix": {
      "addColumn": "Ajouter une colonne",
      "addRow": "Ajouter une ligne",
      "columnPlaceholder": "Libellé de colonne...",
      "columns": "Colonnes",
      "optionsRange": "{{from}} - {{to}} sur {{total}} options",
      "rowPlaceholder": "Libellé de ligne...",
      "rows": "Lignes",
      "rowsRange": "{{from}} - {{to}} sur {{total}} lignes"
    },
    "minMediaHint": {
      "one": "Ajoutez au moins {{count}} image",
      "other": "Ajoutez au moins {{count}} images"
    },
    "minOptionsHint": {
      "one": "Ajoutez au moins {{count}} option",
      "other": "Ajoutez au moins {{count}} options"
    },
    "noLinesProvided": "Ajouter des lignes",
    "noOptionsProvided": "Ajouter des options",
    "noTrackDestinations": "Définir une destination pour chaque parcours",
    "npsExtremelyLikely": "Très probable",
    "npsExtremelyUnlikely": "Très peu probable",
    "option": "Option {{number}}",
    "optionsLabel": "Options",
    "outOfStars": "sur {{count}} étoiles",
    "pricingPlaceholder": "Saisir un prix…",
    "probabilityRulesSeparator": " • ",
    "probabilitySumError": "⚠️ La somme des probabilités doit être inférieure ou égale à 100% (actuellement {{sum}})",
    "questionPlaceholder": "Que souhaitez-vous demander ?",
    "ranking": {
      "addItem": "Ajouter un élément",
      "itemPlaceholder": "Élément à classer...",
      "itemsLabel": "Éléments à classer"
    },
    "removeRule": "Supprimer la règle",
    "restoreQuestion": "Restaurer la question",
    "rulePrecedence": "Règles par option > Règles conditionnelles > Règles de probabilité > Règle par défaut",
    "scaleLabel": "Échelle",
    "selectOption": "Sélectionner une option",
    "selectScale": "Sélectionner l'échelle",
    "skipLogic": "Logique de saut",
    "skipToLabel": "Passer à :",
    "skipToQuestion": "Passer à {{number}}",
    "skipToQuestionWithProbability": "{{percentage}} Passer à {{number}}",
    "stars": {
      "one": "{{count}} étoile",
      "other": "{{count}} étoiles",
      "zero": "{{count}} étoiles"
    },
    "types": {
      "categoryAssignment": "Affectation des parcours",
      "linearScale": "Échelle linéaire",
      "multiSelectMatrix": "Matrice à sélection multiple",
      "multipleChoice": "Choix multiples",
      "nps": "NPS",
      "openEnded": "Question ouverte",
      "pricing": "Prix",
      "ranking": "Classement",
      "ratingScale": "Évaluation",
      "singleChoice": "Choix unique",
      "singleSelectMatrix": "Matrice à sélection unique"
    },
    "untitled": "Question sans titre",
    "useImagesAsOptions": "Utiliser des images comme options",
    "whenAnswer": "Quand la réponse",
    "yourQuestion": "Votre question"
  },
  "runs": {
    "applyFilters": {
      "one": "Appliquer ({{count}} répondant)",
      "other": "Appliquer ({{count}} répondants)",
      "zero": "Appliquer (aucun répondant)"
    },
    "fetchingRespondents": "Récupération des répondants...",
    "filters": "Filtres"
  },
  "sharing": {
    "addPeople": "Ajouter par nom ou email...",
    "directAccess": "Personnes avec accès",
    "editPermission": "Modifier",
    "errorLoading": "Impossible de charger les permissions",
    "external": "Externe",
    "generalAccess": "Accès général",
    "inheritedFrom": "Hérité de « {{name}} »",
    "manageAccess": "Partager « {{name}} »",
    "owner": "Propriétaire",
    "restricted": "Restreint",
    "share": "Partager",
    "viewPermission": "Voir",
    "you": "(vous)"
  },
  "studies": {
    "addSection": "Ajouter une section",
    "allStudies": "Toutes les études",
    "answersProgress": {
      "one": "{{completed}}/{{count}} réponse collectée",
      "other": "{{completed}}/{{count}} réponses collectées"
    },
    "archiveStudy": "Archiver l'étude",
    "cell": "Cellule {{number}}",
    "cells": {
      "addCell": "Ajouter une cellule",
      "addField": "Ajouter une variable",
      "cellNumber": "Cellule {{number}}",
      "cells": "Cellules",
      "fieldNamePlaceholder": "Nom de la variable",
      "noVariables": "Définissez d'abord des variables pour ajouter des cellules.",
      "removeCell": "Supprimer la cellule",
      "removeField": "Supprimer le champ",
      "required": "Obligatoire",
      "type": "Type",
      "typeImage": "Image",
      "typeText": "Texte",
      "variables": "Variables",
      "variablesHint": "Utilisez une variable dans vos questions comme ceci :"
    },
    "confirmArchiveMessage": "Êtes-vous sûr de vouloir archiver cette étude ? Elle sera déplacée dans les archives.",
    "confirmDeletePermanentlyMessage": "Voulez-vous vraiment supprimer définitivement cette étude ? Toutes les données seront supprimées. Cette action est irréversible.",
    "confirmDeleteSection": "Supprimer la section",
    "confirmDeleteSectionMessage": "Êtes-vous sûr de vouloir supprimer cette section ? Toutes les questions de cette section seront déplacées. Cette action ne peut pas être annulée.",
    "confirmRestoreMessage": "Voulez-vous vraiment restaurer cette étude ? Elle sera de nouveau visible.",
    "copyOf": "Copie de {{name}}",
    "coverPicture": "Image de couverture",
    "createFirstStudy": "Créez votre première étude",
    "createFirstStudyDescription": "Remplissez les détails pour créer votre première étude de recherche",
    "createNewStudy": "Créer une nouvelle étude",
    "createNewStudyDescription": "Remplissez les détails pour créer une nouvelle étude de recherche",
    "createStudy": "Créer une étude",
    "deleteStudyPermanently": "Supprimer définitivement l'étude",
    "design": {
      "createStudy": "Créer l'étude",
      "designStudy": "Concevoir l'étude",
      "designing": "Conception en cours...",
      "leave": "Quitter",
      "leaveBody": "Un brouillon d'étude est en cours de relecture. Quitter cette page le supprimera.",
      "leaveTitle": "Quitter et supprimer le brouillon ?",
      "noPanelsFound": "Aucun segment trouvé",
      "placeholder": "ex. Tester trois claims pour notre nouvelle boisson à l'avoine auprès de @Snackeurs Gen Z et comparer l'intention d'achat...",
      "regenerate": "Régénérer",
      "subtitle": "Décrivez ce que vous voulez apprendre et taguez les segments à interroger. Tapez @ pour mentionner un segment.",
      "title": "Que voulez-vous apprendre ?"
    },
    "duplicateStudy": "Dupliquer l'étude",
    "duplicateStudyDescription": "Créer une copie de cette étude avec toutes ses questions et groupes",
    "elementsProgress": {
      "one": "{{completed}}/{{count}} élément traité",
      "other": "{{completed}}/{{count}} éléments traités"
    },
    "errorGettingResults": "Échec de l'obtention des résultats",
    "errorGettingSimulationProgress": "Échec de l'obtention de la progression de la simulation",
    "errorLoadingChat": "Échec du chargement du chat",
    "errorLoadingStudies": "Échec du chargement des études",
    "errorLoadingStudy": "Échec du chargement de l'étude",
    "errorRunningSimulation": "Échec de l'exécution de la simulation",
    "exportExcel": "Exporter en Excel",
    "exportPDF": "Exporter en PDF",
    "exportWord": "Exporter en Docx",
    "exporting": "Exportation...",
    "filterByType": "Filtrer par type",
    "group": "Groupe {{index}}",
    "keyTakeaways": "Points clés",
    "noChatMessages": "Aucun message pour le moment",
    "noDescription": "Aucune description fournie",
    "noResultsYet": "Aucun résultat pour l'instant",
    "noResultsYetDescription": "Lancez une simulation pour voir les résultats ici.",
    "preparingContent": "Préparation du contenu...",
    "qualitative": "Études qualitatives",
    "qualitativeDescription": "Informations riches avec explications détaillées et résumés",
    "qualitativeShort": "Qualitative",
    "quantitative": "Études quantitatives",
    "quantitativeDescription": "Résultats rapides axés sur les données numériques",
    "quantitativeShort": "Quantitative",
    "quickInsightsNudge": "Vous testez une seule question ? Essayez",
    "redirectingToResults": "Redirection vers vos résultats…",
    "respondentsProgress": {
      "one": "{{completed}}/{{count}} répondant",
      "other": "{{completed}}/{{count}} répondants"
    },
    "restoreStudy": "Restaurer l'étude",
    "runInQueue": "Votre étude est en file d'attente et démarrera sous peu",
    "runWaitingToStart": "En attente de démarrage",
    "sectionEditor": {
      "addStimulus": "Ajouter un élément",
      "cellsPerRespondent": "Cellules par répondant",
      "cellsPerRespondentHint": {
        "one": "Chaque répondant voit 1 cellule.",
        "other": "Chaque répondant voit {{count}} cellules."
      },
      "description": "Contexte pour les répondants",
      "descriptionPlaceholder": "Décrivez le produit, la marque ou le scénario auquel les répondants vont réagir.",
      "itemsPerCell": "Éléments par écran",
      "itemsPerCellHint": {
        "one": "1 stimulus est affiché par écran.",
        "other": "{{count}} stimuli sont affichés ensemble sur chaque écran."
      },
      "products": {
        "addStimulus": "Ajouter un produit",
        "stimuli": "Produits",
        "stimulusPlaceholder": "Produit {{index}}",
        "summaryNoStimuli": "Ajouter des produits",
        "summaryStimuli": {
          "one": "1 produit",
          "other": "{{count}} produits"
        }
      },
      "requiresMediaHint": "Une image est requise pour chaque élément.",
      "settings": "Configuration",
      "stimuli": "Éléments",
      "stimulusPlaceholder": "Élément {{index}}",
      "summaryCells": {
        "one": "1 cellule par répondant",
        "other": "{{count}} cellules par répondant"
      },
      "summaryItems": {
        "one": "1 élément par cellule",
        "other": "{{count}} éléments par cellule"
      },
      "summaryNoStimuli": "Ajouter des cellules",
      "summaryStimuli": {
        "one": "1 élément",
        "other": "{{count}} éléments"
      },
      "title": "Titre de la section",
      "titlePlaceholder": "Entrez le titre de la section…",
      "useCase": {
        "ad_creative": {
          "addStimulus": "Ajouter une publicité",
          "cellsPerRespondent": "Publicités par répondant",
          "cellsPerRespondentHint": {
            "one": "Chaque répondant évalue 1 publicité.",
            "other": "Chaque répondant évalue {{count}} publicités."
          },
          "requiresMediaHint": "Ajoutez une image ou une vidéo pour chaque publicité.",
          "stimuli": "Publicités",
          "stimulusPlaceholder": "Publicité {{index}}",
          "summaryCells": {
            "one": "1 publicité par répondant",
            "other": "{{count}} publicités par répondant"
          },
          "summaryNoStimuli": "Ajouter des publicités",
          "summaryStimuli": {
            "one": "1 publicité",
            "other": "{{count}} publicités"
          }
        },
        "awareness": {
          "addStimulus": "Ajouter une marque",
          "stimuli": "Marques",
          "stimulusPlaceholder": "Marque {{index}}",
          "summaryNoStimuli": "Ajouter des marques",
          "summaryStimuli": {
            "one": "1 marque",
            "other": "{{count}} marques"
          }
        },
        "claim_test": {
          "addStimulus": "Ajouter une promesse",
          "cellsPerRespondent": "Promesses par répondant",
          "cellsPerRespondentHint": {
            "one": "Chaque répondant évalue 1 promesse.",
            "other": "Chaque répondant évalue {{count}} promesses."
          },
          "stimuli": "Promesses",
          "stimulusPlaceholder": "Promesse {{index}}",
          "summaryCells": {
            "one": "1 promesse par répondant",
            "other": "{{count}} promesses par répondant"
          },
          "summaryNoStimuli": "Ajouter des promesses",
          "summaryStimuli": {
            "one": "1 promesse",
            "other": "{{count}} promesses"
          }
        },
        "max_diff": {
          "cellsPerRespondent": "Tâches par répondant",
          "cellsPerRespondentHint": {
            "one": "Chaque répondant fait 1 tâche MaxDiff.",
            "other": "Chaque répondant fait {{count}} tâches MaxDiff."
          },
          "itemsPerCell": "Éléments par tâche",
          "itemsPerCellHint": {
            "one": "1 élément est affiché par tâche MaxDiff.",
            "other": "{{count}} éléments sont affichés dans chaque tâche MaxDiff."
          },
          "summaryCells": {
            "one": "1 tâche par répondant",
            "other": "{{count}} tâches par répondant"
          },
          "summaryItems": {
            "one": "1 élément par tâche",
            "other": "{{count}} éléments par tâche"
          }
        },
        "monadic": {
          "addStimulus": "Ajouter un concept",
          "cellsPerRespondent": "Concepts par répondant",
          "cellsPerRespondentHint": {
            "one": "Chaque répondant évalue 1 concept.",
            "other": "Chaque répondant évalue {{count}} concepts."
          },
          "stimuli": "Concepts",
          "stimulusPlaceholder": "Concept {{index}}",
          "summaryCells": {
            "one": "1 concept par répondant",
            "other": "{{count}} concepts par répondant"
          },
          "summaryNoStimuli": "Ajouter des concepts",
          "summaryStimuli": {
            "one": "1 concept",
            "other": "{{count}} concepts"
          }
        },
        "packaging": {
          "addStimulus": "Ajouter un packaging",
          "cellsPerRespondent": "Packagings par répondant",
          "cellsPerRespondentHint": {
            "one": "Chaque répondant évalue 1 packaging.",
            "other": "Chaque répondant évalue {{count}} packagings."
          },
          "requiresMediaHint": "Ajoutez une image pour chaque packaging.",
          "stimuli": "Packagings",
          "stimulusPlaceholder": "Packaging {{index}}",
          "summaryCells": {
            "one": "1 packaging par répondant",
            "other": "{{count}} packagings par répondant"
          },
          "summaryNoStimuli": "Ajouter des packagings",
          "summaryStimuli": {
            "one": "1 packaging",
            "other": "{{count}} packagings"
          }
        },
        "preference_test": {
          "addStimulus": "Ajouter une variante",
          "stimuli": "Variantes",
          "stimulusPlaceholder": "Variante {{index}}",
          "summaryNoStimuli": "Ajouter des variantes",
          "summaryStimuli": {
            "one": "1 variante",
            "other": "{{count}} variantes"
          }
        },
        "price_elasticity": {
          "cellsPerRespondent": "Produits par répondant",
          "cellsPerRespondentHint": {
            "one": "Chaque répondant fixe le prix de 1 produit.",
            "other": "Chaque répondant fixe le prix de {{count}} produits."
          },
          "summaryCells": {
            "one": "1 produit par répondant",
            "other": "{{count}} produits par répondant"
          }
        }
      }
    },
    "shareDescription": "Voici un lien public vers votre étude. Toute personne disposant de ce lien peut consulter cette étude en lecture seule.",
    "shareResults": "Partager les résultats",
    "shareTitle": "Partager les résultats",
    "sharing": "Partage en cours...",
    "startChattingWithAI": "Commencez à discuter avec l'IA pour analyser les résultats de votre étude",
    "studyChat": "Chat de l'étude",
    "studyDescription": "Description",
    "studyDescriptionPlaceholder": "Entrez une description détaillée de votre étude...",
    "studyName": "Nom",
    "studyNamePlaceholder": "Entrez le nom de l'étude...",
    "studyType": "Type d'étude",
    "summariesProgress": {
      "one": "{{completed}}/{{count}} résumé",
      "other": "{{completed}}/{{count}} résumés"
    },
    "summaryLoadingAnalyzing": "Analyse des tendances par segment de répondants…",
    "summaryLoadingCompiling": "Compilation des résultats par démographie et segment…",
    "summaryLoadingDrafting": "Rédaction du résumé exécutif et des recommandations…",
    "summaryLoadingIdentifying": "Identification des thèmes clés et des signaux de sentiment…",
    "timeElapsed": "Temps écoulé : {{time}}",
    "timeRemaining": "Temps restant estimé : {{time}}",
    "triggeringSimulation": "Démarrage...",
    "typeYourMessage": "Tapez votre message...",
    "useCasePicker": {
      "custom": "Section personnalisée",
      "customDescription": "Partez d'une section vierge et ajoutez vos propres questions.",
      "title": "Choisissez un cas d'usage pour commencer"
    },
    "viewDetailed": "Voir le détail",
    "viewReport": "Voir le rapport",
    "waitingForProgress": "En attente de progression...",
    "workingOnItMessage": "Prenez un café pendant que nous menons votre étude...",
    "workingOnItMessageAlmostReady": "Plus que quelques instants, vos insights arrivent bientôt..."
  },
  "useCasePage": {
    "adCreative": {
      "ctaSubtitle": "Obtenez les réactions à vos publicités en moins de 10 minutes.",
      "ctaTitle": "Lancer un test de création publicitaire",
      "methodology": {
        "description": "Chaque répondant regarde l'ensemble de vos publicités, une par une, et répond aux mêmes cinq questions sur chacune. Comme chaque publicité est évaluée seule, les scores reflètent des réactions autonomes, comme si elle était diffusée en conditions réelles.",
        "metrics": {
          "likingIndex": {
            "description": "Un score combiné qui agrège l'agrément, la cohérence avec la marque et l'intérêt d'achat, pour donner un seul chiffre comparable par publicité.",
            "title": "Indice d'agrément"
          },
          "takeaway": {
            "description": "Ce que les consommateurs pensent vraiment que la publicité dit, avec leurs propres mots.",
            "title": "Thèmes retenus"
          }
        },
        "name": "Monadique séquentiel"
      },
      "provide": {
        "description": "1 à 5 créations publicitaires : images, animatiques ou clips courts. Un titre de travail court pour chacune rend le rapport plus lisible.",
        "examples": {
          "functional": {
            "description": "Spot produit de 15 secondes axé sur la dorure et un appel précis sur le pourcentage de cacao.",
            "name": "Gros plan fonctionnel"
          },
          "heritage": {
            "description": "Film cinématographique de 60 secondes retraçant une fève de cacao d'une ferme ghanéenne jusqu'à la tablette finie.",
            "name": "Spot Héritage emblématique"
          },
          "lifestyle": {
            "description": "Scène urbaine de 30 secondes avec des amis partageant la tablette lors d'un dîner sur un toit-terrasse.",
            "name": "Moment de vie"
          }
        },
        "title": "Vos publicités"
      },
      "sampleReport": {
        "ads": {
          "functional": {
            "name": "Gros plan fonctionnel"
          },
          "heritage": {
            "name": "Héritage emblématique"
          },
          "lifestyle": {
            "name": "Moment de vie"
          }
        },
        "metrics": {
          "brandFit": "Cohérence marque",
          "interest": "Intérêt",
          "liking": "Agrément",
          "subtitle": "Part top 2 boîtes pour chaque publicité sur chaque échelle, accompagnée du thème retenu.",
          "title": "Performance de chaque publicité, par métrique"
        },
        "ranking": {
          "subtitle": "Score combiné des trois questions de notation, sur une échelle de 0 à 100.",
          "title": "Indice d'agrément par publicité"
        },
        "subjectLine": "Étude synthétique, n = {{count}} consommateurs, 3 publicités testées.",
        "summary": {
          "body": "Héritage emblématique obtient le meilleur score combiné grâce à un récit clair et une forte cohérence avec la marque. Moment de vie est perçu comme amusant mais générique : agrément élevé, cohérence marque faible. Gros plan fonctionnel est le plus simple à comprendre mais le plus difficile à faire ressentir : la compréhension est presque parfaite, l'intention la plus faible des trois.",
          "headline": "Héritage emblématique mène en agrément et en intention, tandis que Gros plan fonctionnel l'emporte sur la clarté mais perd sur l'émotion."
        },
        "winner": {
          "badge": "Création en tête",
          "compositeLabel": "Indice d'agrément",
          "subtitle": "Meilleur score combiné en agrément, cohérence marque et intérêt."
        }
      }
    },
    "awareness": {
      "ctaSubtitle": "Obtenez un entonnoir de notoriété propre en moins de 10 minutes.",
      "ctaTitle": "Lancer une étude de notoriété",
      "methodology": {
        "description": "La notoriété est mesurée en deux étapes, dans un ordre fixe pour éviter tout amorçage. D'abord, les répondants tapent les marques qui leur viennent à l'esprit pour la catégorie. Ensuite, on leur montre votre liste complète et ils cochent toutes les marques qu'ils connaissent. Les mentions spontanées sont ensuite comparées à la même liste pour calculer la notoriété spontanée.",
        "metrics": {
          "aided": {
            "description": "Pourcentage de répondants qui reconnaissent une marque lorsqu'on leur présente votre liste de candidats. Le plafond : la familiarité passive.",
            "title": "Notoriété assistée"
          },
          "unaided": {
            "description": "Pourcentage de répondants qui citent spontanément une marque, sans liste affichée. La barre la plus haute : le rappel actif.",
            "title": "Notoriété spontanée"
          }
        },
        "name": "Entonnoir de notoriété en deux étapes"
      },
      "provide": {
        "description": "Les marques que vous voulez mesurer. 3 à 15 marques.",
        "title": "Liste de marques"
      },
      "sampleReport": {
        "brands": {
          "cadbury": "Cadbury",
          "ferrero": "Ferrero Rocher",
          "ghirardelli": "Ghirardelli",
          "godiva": "Godiva",
          "hersheys": "Hershey's",
          "lindt": "Lindt",
          "milka": "Milka",
          "toblerone": "Toblerone"
        },
        "chart": {
          "aidedLabel": "Assistée",
          "subtitle": "Mentions spontanées vs. reconnaissance dans la liste, par marque.",
          "title": "Entonnoir de notoriété",
          "unaidedLabel": "Spontanée"
        },
        "subjectLine": "Étude synthétique, n = {{count}} consommateurs, catégorie chocolat premium.",
        "summary": {
          "body": "L'entonnoir cache plusieurs renversements. Cadbury (38 % en spontanée) devance Hershey's (33 %) malgré une couverture assistée plus faible, signe que la position top-of-mind ne suit pas le rang en assistée. Toblerone (82 % assistée / 16 % spontanée) et Godiva (71 % / 8 %) affichent les plus grands écarts reconnaissance-sans-rappel du panel : les consommateurs connaissent les noms mais ils n'émergent pas quand on évoque la catégorie. Milka détient le meilleur ratio spontanée-sur-assistée du panel, suggérant une base de mindshare réduite mais fidèle.",
          "headline": "Lindt est la marque top-of-mind de la catégorie avec 54 % en spontanée et 91 % en assistée, soit 16 points d'avance sur Cadbury, la marque suivante en rappel spontané."
        },
        "topOfMind": {
          "badge": "Top-of-mind",
          "subtitle": "Marque la plus citée par les répondants quand ils tapaient sans liste affichée.",
          "unaidedLabel": "Rappel spontané"
        }
      }
    },
    "claimTest": {
      "ctaSubtitle": "Choisissez le bon claim en moins de 10 minutes.",
      "ctaTitle": "Lancer un test de claim",
      "methodology": {
        "description": "Chaque répondant lit chaque claim, un par un, et répond aux mêmes questions sur chacun. Comme chaque claim est jugé seul, les scores reflètent comment il est réellement perçu, sans la distorsion d'une comparaison directe.",
        "metrics": {
          "meaning": {
            "description": "Ce que les consommateurs pensent que le claim signifie réellement, avec leurs propres mots.",
            "title": "Test de sens"
          },
          "persuasion": {
            "description": "Un score combiné agrégeant crédibilité, distinction et motivation, pour donner un seul chiffre comparable par claim.",
            "title": "Score de persuasion"
          }
        },
        "name": "Monadique séquentiel"
      },
      "provide": {
        "description": "1 à 5 claims, slogans ou promesses produit. Restez court : une phrase fonctionne le mieux.",
        "examples": {
          "craft": "70 heures de conchage lent pour une finition plus soyeuse et plus profonde.",
          "origin": "Cacao ghanéen d'origine unique, sourcé de manière éthique et pressé à froid.",
          "purpose": "10 % de chaque tablette finance le reboisement en Afrique de l'Ouest."
        },
        "title": "Vos claims"
      },
      "sampleReport": {
        "claims": {
          "craft": {
            "name": "70 heures de conchage lent"
          },
          "origin": {
            "name": "Cacao ghanéen d'origine unique"
          },
          "purpose": {
            "name": "10 % finance le reboisement"
          }
        },
        "metrics": {
          "believability": "Crédible",
          "motivation": "Motivant",
          "subtitle": "Part top 2 boîtes pour chaque claim sur chaque échelle, avec la lecture qu'en font les répondants.",
          "title": "Performance de chaque claim, par métrique",
          "uniqueness": "Différent"
        },
        "ranking": {
          "subtitle": "Score combiné des trois questions de notation, sur une échelle de 0 à 100.",
          "title": "Score de persuasion par claim"
        },
        "subjectLine": "Étude synthétique, n = {{count}} consommateurs, 3 claims testés.",
        "summary": {
          "body": "Cacao ghanéen d'origine unique obtient le meilleur score combiné grâce à un sens clair et une forte crédibilité. Le claim sur le conchage est le plus distinctif mais le plus difficile à concrétiser : la moitié des répondants ne savent pas pourquoi ça compte. Le claim de mission émeut mais paraît familier, car beaucoup attendent déjà un sourcing éthique des marques premium.",
          "headline": "Le claim d'origine gagne sur la persuasion et la motivation ; le claim de mission résonne mais paraît moins distinctif."
        },
        "winner": {
          "badge": "Claim en tête",
          "compositeLabel": "Score de persuasion",
          "subtitle": "Meilleur score combiné en crédibilité, distinction et motivation."
        }
      }
    },
    "example": "Exemple",
    "getStarted": "Commencer",
    "maxDiff": {
      "ctaSubtitle": "La configuration prend moins de 2 minutes : collez votre liste d'éléments et nous nous occupons du reste.",
      "ctaTitle": "Lancer une étude MaxDiff",
      "methodology": {
        "description": "Plutôt que de demander aux répondants de noter chaque élément individuellement, où la plupart finissent bien notés, MaxDiff présente de petits sous-ensembles et demande de choisir le meilleur et le pire de chaque. Répété sur de nombreux tours, cela produit un classement précis avec des écarts nets entre les éléments.",
        "metrics": {
          "discrimination": {
            "description": "Distinctions plus nettes que les échelles de notation, même lorsque tous les éléments plaisent individuellement",
            "title": "Discrimination"
          },
          "preferenceScore": {
            "description": "Classement pondéré par utilité qui quantifie la préférence relative pour chaque élément",
            "title": "Score de préférence"
          }
        },
        "name": "Méthode du meilleur et du pire"
      },
      "provide": {
        "description": "4 à 20 fonctionnalités, messages ou attributs distincts à prioriser. Des formulations courtes et claires fonctionnent le mieux.",
        "title": "Liste d'éléments"
      },
      "sampleReport": {
        "chart": {
          "subtitle": "Chaque barre montre l'écart d'un élément par rapport à la préférence moyenne. Les barres à droite indiquent une préférence supérieure à la moyenne, celles à gauche une préférence inférieure.",
          "title": "Scores de préférence"
        },
        "items": {
          "artisans": "Fabriqué par de petits artisans",
          "fairTrade": "Certifié commerce équitable",
          "lowSugar": "Faible teneur en sucre",
          "premium": "Expérience chocolat noir premium",
          "richFlavor": "Saveur intense et riche",
          "singleOrigin": "Cacao d'origine unique",
          "smoothTexture": "Texture onctueuse",
          "sustainable": "Emballage durable",
          "unique": "Accords de saveurs uniques",
          "variety": "Large variété de saveurs"
        },
        "subjectLine": "Attributs d'une tablette de chocolat premium · n = {{count}}",
        "summary": {
          "body": "Les leviers sensoriels dominent : richesse en goût, teneur en sucre réduite et texture fondante représentent à eux trois 46 % de la préférence totale. Les arguments à mission (sourcing durable, commerce équitable, fabrication artisanale en petits lots) se situent au niveau ou en dessous de la moyenne de 10 %, suggérant qu'ils rassurent plus qu'ils ne déclenchent l'achat.",
          "headline": "La richesse intense du goût domine le panel à 18,5 %, presque cinq fois plus que l'argumentaire artisanal en petits lots, à 3,9 %."
        }
      }
    },
    "metricLabel": "Métrique {{letter}}",
    "monadic": {
      "ctaSubtitle": "Obtenez des scores nets et comparables en moins de 10 minutes.",
      "ctaTitle": "Lancer un test de concept",
      "methodology": {
        "description": "En test monadique, chaque répondant se voit attribuer aléatoirement un concept (ou une courte séquence de concepts) tiré de votre pool, et note chacun isolément sur une batterie de cinq questions. Comme aucun répondant ne compare les concepts côte à côte, les scores reflètent l'attrait propre de chaque concept, comme s'il était rencontré en rayon ou à l'écran.",
        "metrics": {
          "compositeScore": {
            "description": "Moyenne des top-2-box sur les cinq métriques. Le score principal utilisé pour classer les concepts.",
            "title": "Score composite"
          },
          "topTwoBox": {
            "description": "Pourcentage des répondants ayant noté une métrique 4 ou 5 sur l'échelle à cinq points. Le KPI standard du test de concept.",
            "title": "Top-2-box"
          }
        },
        "name": "Test de concept monadique"
      },
      "provide": {
        "description": "Votre pool de concepts candidats (1 à 20), chacun avec un nom et une courte description (image facultative).",
        "title": "Pool de concepts"
      },
      "sampleReport": {
        "concepts": {
          "functional": {
            "description": "Une barre enrichie en protéines et faible en sucre, axée sur les modes de vie actifs et le clean-label.",
            "name": "Cocoa+ Functional"
          },
          "heritage": {
            "description": "Une tablette premium d'origine unique, avec traçabilité fève à fève et récit sur la durabilité.",
            "name": "Heritage Cocoa Co."
          },
          "velvet": {
            "description": "Un chocolat au lait fondant du quotidien, calibré pour les courses hebdomadaires en famille.",
            "name": "Velvet Daily"
          }
        },
        "heatmap": {
          "subtitle": "Scores top-2-box par concept (les cellules sont teintées selon le score ; plus c'est foncé, plus c'est fort).",
          "title": "Détail par métrique"
        },
        "metrics": {
          "purchaseIntent": "Intention d'achat",
          "recommend": "Probabilité de recommander",
          "relevance": "Pertinence pour moi",
          "uniqueness": "Caractère unique",
          "valueForMoney": "Rapport qualité-prix"
        },
        "ranking": {
          "subtitle": "Score composite top-2-box, moyenné sur les cinq métriques.",
          "title": "Classement des concepts"
        },
        "subjectLine": "Étude synthétique, n = {{count}} consommateurs ({{perCell}} par concept), 3 concepts candidats.",
        "summary": {
          "body": "Heritage incarne le récit premium : caractère unique (78 %) et probabilité de recommander (71 %) ancrent sa victoire, mais Velvet Daily est le champion du rapport qualité-prix (72 %) et le concept le plus pertinent (64 %), ce qui en fait un contrepoids naturel pour le quotidien. L'angle santé restreint de Cocoa+ Functional pèse sur l'intention d'achat (45 %) malgré un score d'unicité honorable, et ne pourra probablement pas porter un lancement à lui seul.",
          "headline": "Heritage Cocoa Co. remporte le composite à 62 %, devançant Velvet Daily de 3,4 points et surpassant Cocoa+ Functional de 13 points."
        },
        "winner": {
          "badge": "Concept gagnant",
          "compositeLabel": "Composite",
          "subtitle": "Score composite top-2-box le plus élevé sur les cinq métriques."
        }
      }
    },
    "notFound": "Cas d'usage introuvable",
    "nps": {
      "ctaSubtitle": "Deux questions, un seul score, prêt en moins d'une minute.",
      "ctaTitle": "Lancer une étude NPS",
      "methodology": {
        "description": "Le Net Promoter Score est l'indicateur de fidélité standard de l'industrie. Les répondants notent leur probabilité de recommander sur une échelle de 0 à 10, puis justifient brièvement leur note. Les scores sont regroupés en Détracteurs (0–6), Passifs (7–8) et Promoteurs (9–10), et NPS = %Promoteurs − %Détracteurs. La justification ouverte transforme un chiffre brut en thèmes actionnables.",
        "metrics": {
          "breakdown": {
            "description": "Part de Détracteurs (0–6), Passifs (7–8) et Promoteurs (9–10) : le profil de fidélité derrière le score.",
            "title": "Profil de fidélité"
          },
          "score": {
            "description": "%Promoteurs moins %Détracteurs, sur une échelle de −100 à +100. Le chiffre unique pour suivre la fidélité dans le temps.",
            "title": "Score NPS"
          }
        },
        "name": "Net Promoter Score"
      },
      "provide": {
        "description": "Une courte description du produit, du service ou de l'expérience évaluée.",
        "example": "Tablette de chocolat noir premium (70 % cacao, 100 g) : produit phare, six mois après une modification récente de la recette.",
        "title": "Ce que vous mesurez"
      },
      "sampleReport": {
        "chart": {
          "subtitle": "Détracteurs 0–6 · Passifs 7–8 · Promoteurs 9–10. Les barres montrent la part de répondants à chaque score.",
          "title": "Distribution des scores"
        },
        "score": {
          "badge": "Score principal",
          "classification": "Bon",
          "subtitle": "Au-dessus de zéro et en territoire solide : les promoteurs l'emportent confortablement sur les détracteurs, avec de la marge pour progresser."
        },
        "segments": {
          "count": "{{count}} répondants",
          "detractors": {
            "band": "Notes 0–6"
          },
          "passives": {
            "band": "Notes 7–8"
          },
          "promoters": {
            "band": "Notes 9–10"
          }
        },
        "subjectLine": "Tablette de chocolat noir premium · n = {{count}} consommateurs",
        "summary": {
          "body": "Le plus grand groupe se situe dans la zone passive : 33 % des répondants donnent un 7 ou un 8 : satisfaits, mais pas enthousiastes. Convertir ne serait-ce que la moitié d'entre eux en promoteurs ferait passer le NPS au-dessus de +50, dans le quartile supérieur. La base de détracteurs est faible (18 %) et concentrée sur les notes de 6 plutôt que sur le plancher 0–3, ce qui suggère des frictions corrigeables plutôt qu'une insatisfaction profonde.",
          "headline": "Un NPS de +31 place la tablette en territoire solide de fidélité, avec des promoteurs (49 %) clairement au-dessus des détracteurs (18 %)."
        }
      }
    },
    "packaging": {
      "ctaSubtitle": "Choisissez le packaging qui gagne en rayon en moins de 10 minutes.",
      "ctaTitle": "Lancer un test de packaging",
      "methodology": {
        "description": "Chaque répondant voit l'ensemble de vos designs de packaging, un par un, et répond aux mêmes questions sur chacun. Comme chaque packaging est jugé seul, les scores reflètent la perception réelle de chaque design, sans le biais d'une comparaison côte à côte.",
        "metrics": {
          "clarity": {
            "description": "Si les consommateurs identifient correctement de quel produit il s'agit, juste en regardant le packaging.",
            "title": "Test de clarté"
          },
          "shelfAppeal": {
            "description": "Un score combiné agrégeant attrait et intention de prise en rayon, pour donner un seul chiffre comparable par packaging.",
            "title": "Attrait en rayon"
          }
        },
        "name": "Monadique séquentiel"
      },
      "provide": {
        "description": "1 à 5 designs de packaging sous forme d'images. Un titre de travail court pour chacun rend le rapport plus lisible.",
        "examples": {
          "heritage": {
            "description": "Motif de cabosse de cacao dessiné à la main sur une base façon kraft, blason de la marque centré en haut.",
            "name": "Héritage illustré"
          },
          "minimalist": {
            "description": "Typographie serif épurée sur une jaquette mate satinée avec un pourcentage estampé à la feuille d'or.",
            "name": "Minimaliste dorure"
          },
          "vibrant": {
            "description": "Bloc de couleur vive, logo sans serif, nom de la saveur en typographie surdimensionnée.",
            "name": "Moderne vibrant"
          }
        },
        "title": "Vos packagings"
      },
      "sampleReport": {
        "metrics": {
          "appeal": "Attrait",
          "brandFit": "Cohérence marque",
          "shelfIntent": "Prise en rayon",
          "subtitle": "Part top 2 boîtes pour chaque packaging sur chaque échelle, avec la lecture qu'en font les répondants.",
          "title": "Performance de chaque packaging, par métrique"
        },
        "packs": {
          "heritage": {
            "name": "Héritage illustré"
          },
          "minimalist": {
            "name": "Minimaliste dorure"
          },
          "vibrant": {
            "name": "Moderne vibrant"
          }
        },
        "ranking": {
          "subtitle": "Score combiné des trois questions de notation, sur une échelle de 0 à 100.",
          "title": "Attrait en rayon par packaging"
        },
        "subjectLine": "Étude synthétique, n = {{count}} consommateurs, 3 packagings testés.",
        "summary": {
          "body": "Minimaliste dorure obtient le meilleur score combiné grâce à une forte intention de prise en rayon et une bonne cohérence avec la marque. Héritage illustré est perçu comme le plus premium et le plus distinctif, mais ses illustrations rendent un tiers des répondants confus quant à la nature réelle du produit. Moderne vibrant est reconnu le plus vite mais paraît le moins premium des trois.",
          "headline": "Minimaliste dorure gagne sur l'attrait et l'intention de prise ; Héritage illustré envoie le signal premium le plus fort."
        },
        "winner": {
          "badge": "Packaging en tête",
          "compositeLabel": "Attrait en rayon",
          "subtitle": "Meilleur score combiné sur l'attrait et l'intention de prise."
        }
      }
    },
    "pastResults": "Résultats passés",
    "preferenceTest": {
      "ctaSubtitle": "Désignez un gagnant en moins de 10 minutes.",
      "ctaTitle": "Lancer un test de préférence",
      "methodology": {
        "description": "Chaque répondant voit toutes vos options sur le même écran et choisit celle qu'il préfère, puis explique pourquoi avec ses propres mots. Comme c'est un choix direct, vous obtenez un gagnant clair et les raisons derrière le verdict.",
        "metrics": {
          "reasons": {
            "description": "Principaux thèmes issus des explications ouvertes, regroupés par option gagnante.",
            "title": "Raisons de gagner"
          },
          "winRate": {
            "description": "Part des répondants ayant choisi chaque option comme leur favorite.",
            "title": "Part de gain"
          }
        },
        "name": "Comparaison à choix forcé"
      },
      "provide": {
        "description": "2 à 5 options à comparer. Ce peut être des images (publicités, packagings) ou de courts textes (claims, slogans).",
        "examples": {
          "optionA": {
            "description": "Film cinématographique retraçant le parcours d'une fève de cacao, de la ferme à la tablette.",
            "name": "Option A : Héritage emblématique"
          },
          "optionB": {
            "description": "Des amis partageant la tablette lors d'un dîner sur un toit-terrasse.",
            "name": "Option B : Moment de vie"
          },
          "optionC": {
            "description": "Plan serré sur le produit, axé sur la dorure et le pourcentage de cacao.",
            "name": "Option C : Gros plan fonctionnel"
          }
        },
        "title": "Vos options"
      },
      "sampleReport": {
        "options": {
          "optionA": {
            "name": "Héritage emblématique",
            "themes": "Récit · savoir-faire · authenticité"
          },
          "optionB": {
            "name": "Moment de vie",
            "themes": "Convivial · partageable · paraît générique"
          },
          "optionC": {
            "name": "Gros plan fonctionnel",
            "themes": "Produit clair · oubliable"
          }
        },
        "reasons": {
          "subtitle": "Principaux thèmes issus des explications ouvertes, classés par fréquence.",
          "title": "Pourquoi ils l'ont choisi"
        },
        "share": {
          "subtitle": "Chaque barre montre combien des {{count}} répondants ont choisi cette option comme leur favorite.",
          "title": "Répartition des votes"
        },
        "subjectLine": "Étude synthétique, n = {{count}} consommateurs, 3 publicités comparées.",
        "summary": {
          "body": "L'option Héritage emblématique l'emporte sur le plan émotionnel : les répondants évoquent à plusieurs reprises le voyage de la ferme à la tablette et le sentiment d'être captivés. Le Moment de vie est perçu comme convivial et partageable, mais paraît générique pour les deux tiers des répondants. Le Gros plan fonctionnel est le message le plus clair, mais le moins mémorable : personne ne le mentionne sans qu'on le suggère.",
          "headline": "Héritage emblématique remporte 52 % des votes, soit deux fois plus que son dauphin. C'est le récit qui fait basculer le choix."
        },
        "votesLabel": "{{count}} votes",
        "winner": {
          "badge": "Option en tête",
          "compositeLabel": "Part de gain"
        }
      }
    },
    "priceElasticity": {
      "ctaSubtitle": "La configuration prend moins de 2 minutes grâce à notre modèle automatisé.",
      "ctaTitle": "Lancer une étude de prix",
      "methodology": {
        "description": "Plutôt que de demander « combien seriez-vous prêt à payer ? », cette approche utilise quatre questions spécifiques pour identifier les barrières psychologiques de prix. En cartographiant ces perceptions, nous visualisons l'équilibre entre prix et qualité perçue.",
        "metrics": {
          "opp": {
            "description": "Le point idéal où la résistance des consommateurs est minimisée",
            "title": "Prix optimal (OPP)"
          },
          "range": {
            "description": "Limites entre les seuils « Bon marché » et « Cher »",
            "title": "Fourchette de prix acceptable"
          }
        },
        "name": "La méthodologie Van Westendorp"
      },
      "provide": {
        "description": "Une description claire de votre produit ou service, ou une photo, afin que les répondants aient suffisamment de contexte pour le tarifer.",
        "example": "Tablette de chocolat noir bio premium (70 % de cacao, 100 g), origine unique d'Équateur, issue d'un commerce éthique et emballée dans du papier recyclable.",
        "title": "Description ou photo"
      },
      "questions": {
        "bargain": {
          "title": "Bonne affaire"
        },
        "expensive": {
          "title": "Cher"
        },
        "tooCheap": {
          "title": "Trop bon marché"
        },
        "tooExpensive": {
          "title": "Trop cher"
        }
      }
    },
    "sampleReport": {
      "badge": "Rapport exemple",
      "disclaimer": "Toutes les données affichées sont illustratives.",
      "histogram": {
        "subtitle": "Distribution des prix indiqués par les répondants pour chaque question de seuil.",
        "title": "Distribution des prix"
      },
      "keyInsights": "Points clés",
      "subjectLine": "Tablette de chocolat noir bio premium · n = {{count}}",
      "summary": {
        "body": "Au prix optimal ({{opp}}), une part égale de consommateurs trouvent le produit trop bon marché ou trop cher, minimisant la résistance des deux côtés. Tarifer en dessous de {{pmc}} risque de signaler une qualité médiocre, tandis qu'au-delà de {{pme}}, la plupart des consommateurs sortent du périmètre de considération. Le prix d'indifférence ({{ipp}}) marque le point où autant de consommateurs voient le produit comme une bonne affaire que comme cher, un repère solide pour un positionnement quotidien.",
        "headline": "Le prix optimal se situe à {{opp}}, avec une fourchette acceptable entre {{pmc}} et {{pme}}."
      },
      "vw": {
        "ippLabel": "Indifférence · {{price}}",
        "ippShort": "IPP",
        "oppLabel": "Optimal · {{price}}",
        "oppShort": "OPP",
        "pmcLabel": "Plancher · {{price}}",
        "pmcShort": "PMC",
        "pmeLabel": "Plafond · {{price}}",
        "pmeShort": "PME",
        "subtitle": "Part cumulée des répondants à chaque niveau de prix. Les intersections révèlent le prix optimal et la fourchette acceptable.",
        "title": "Courbes de sensibilité au prix Van Westendorp",
        "xLabel": "Prix"
      }
    },
    "turf": {
      "ctaSubtitle": "Obtenez une réponse en moins de 10 minutes.",
      "ctaTitle": "Lancer une étude TURF",
      "methodology": {
        "description": "TURF (Total Unduplicated Reach and Frequency) teste toutes les combinaisons possibles de votre liste pour trouver l'assortiment qui touche le plus de répondants uniques tout en limitant les chevauchements.",
        "metrics": {
          "frequency": {
            "description": "Nombre moyen d'éléments qu'un répondant retiendrait dans un portefeuille donné.",
            "title": "Fréquence"
          },
          "reach": {
            "description": "Pourcentage de répondants intéressés par au moins un élément du portefeuille.",
            "title": "Couverture non dupliquée"
          }
        },
        "name": "Couverture non dupliquée et fréquence totale"
      },
      "provide": {
        "description": "5 à 20 produits, parfums, fonctionnalités ou messages distincts à proposer. Des formulations courtes et claires fonctionnent mieux.",
        "title": "Liste d'éléments"
      },
      "sampleReport": {
        "chart": {
          "elbowLabel": "Taille optimale",
          "reachLabel": "Couverture non dupliquée",
          "subtitle": "Chaque point indique la part d'audience couverte par le meilleur portefeuille de cette taille. Le point marqué est celui où ajouter un élément n'apporte plus de gain notable.",
          "title": "Couverture par taille de portefeuille",
          "xLabel": "Taille du portefeuille",
          "yLabel": "Couverture"
        },
        "items": {
          "almond": "Chocolat aux amandes",
          "coconut": "Chocolat à la noix de coco",
          "dark": "Chocolat noir (70 % de cacao)",
          "hazelnut": "Chocolat aux noisettes",
          "milk": "Chocolat au lait",
          "mint": "Chocolat à la menthe",
          "orange": "Chocolat à l'orange",
          "raspberry": "Chocolat à la framboise",
          "saltedCaramel": "Chocolat au caramel salé",
          "white": "Chocolat blanc"
        },
        "portfolio": {
          "reachLabel": "Couverture non dupliquée",
          "subtitle": "Assortiment optimal de {{size}} éléments",
          "title": "Portefeuille recommandé"
        },
        "rawCounts": {
          "subtitle": "Combien de répondants envisageraient chaque parfum à titre individuel. L'optimisation ci-dessus s'appuie sur ces signaux pour trouver le plus petit assortiment couvrant le plus d'acheteurs uniques.",
          "title": "Sélection par parfum"
        },
        "subjectLine": "Étude synthétique, n = {{count}} consommateurs, 10 parfums candidats.",
        "summary": {
          "body": "Le chocolat au lait est le déclencheur individuel le plus fort à 37 %, mais l'assortiment optimal ne fonctionne que parce que la menthe touche des acheteurs que les variétés cacaotées n'atteignent pas. Les quatre retardataires (blanc, orange, framboise et coco) sous-performent seuls et n'apportent presque rien une fois les cinq favoris en place.",
          "headline": "Lait, noir, caramel salé, noisette et menthe touchent ensemble 84 % des acheteurs ; ajouter un sixième parfum ne fait gagner que 1,5 point."
        }
      }
    },
    "viewSampleReport": "Voir un rapport exemple",
    "whatYoullProvide": "Ce que vous devrez fournir"
  }
}
